/*
  Studio Pro By Charlot · le calcul du devis.

  Tout se calcule en centimes entiers : aucune addition de nombres a virgule,
  donc la somme des lignes affichees est toujours egale au total affiche.

  Regles validees par Charles le 22/09/2026 :
  - prix affiches hors taxes ; prix d'une piece = plante seule + pot seul (prix TTC Shopify)
  - 30/09/2026 : TVA par nature, comme Shopify la facture (verifie sur les commandes reelles) :
    plante vivante 10 %, pot et etiquette 20 %, livraison 10 %. Avant, tout etait divise par 1,2,
    ce qui sous-estimait le prix HT des plantes d'environ 9 % et faussait le TTC.
  - etiquette personnalisee : 4,17 EUR HT par piece personnalisee
  - remise sur tout le devis hors livraison (plantes, pots, etiquettes), selon le
    nombre total de pieces : -10 % des 10, -15 % des 25, -20 % des 50, -25 % des 100
  - 30/09/2026, recommandation du strategiste (grille_minimum.md), en attente de l'accord de Charles :
    plus de minimum, le Studio s'ouvre des 1 piece (prix du site sous 10, tarif pro des 10) ;
    livraison a une adresse jamais sous 7,90 EUR HT (sinon le port des petites commandes disparait)
  - 30/09/2026, decisions de Charles : Studio des 1 piece ; sous 10 pieces, petite remise de 5 %
    reservee aux entreprises identifiees (SIRET ou TVA) ; grille gardee ; « jamais plus cher en
    commandant moins » : le total est plafonne au prix du palier suivant (24 pieces ne coutent
    jamais plus que 25, 48 ou 49 jamais plus que 50, etc.)
  - livraison a une adresse : 10 % du devis remise, arrondi a la dizaine inferieure,
    jamais plus de 500 EUR HT
  - livraison a chaque destinataire : 7,90 EUR HT par envoi
  - 01/10/2026, decision de Charles : TVA de la livraison B2B a 20 % (« plutot trop payer que pas assez »), sans toucher
    a la boutique grand public. Un seul reglage, REGLES.tvaLivraison : la page, le Worker, le script, le devis PDF, le
    devis Shopify (livraison portee par le produit cache « Livraison professionnelle » de la collection « TVA - 20% »)
    et la facture Pennylane (taux recopies du devis Shopify) le suivent.
  - 19/10/2026, decision de Charles : etiquette personnalisee OFFERTE, logo ou texte, pour toute commande passee du 19/10
    au 15/11/2026 inclus (heure de Paris), REGLES.etiquetteOfferte ; le 16/11 a 0 h, retour seul a 4,17 EUR HT. L'appelant
    decide avec son horloge (etiquetteOfferte) : la page pour l'affichage, le serveur pour le prix, a la reception de la
    demande. Sans l'option, l'etiquette est comptee (jamais offerte par oubli).

  Le meme fichier sert dans la page et dans le script qui recoit la demande :
  le serveur recalcule, il ne croit jamais le prix envoye par le navigateur.
*/
(function (racine, fabrique) {
  if (typeof module === "object" && module.exports) module.exports = fabrique();
  else racine.StudioCalcul = fabrique();
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  const REGLES = {
    paliers: [ { des: 10, taux: 10 }, { des: 25, taux: 15 }, { des: 50, taux: 20 }, { des: 100, taux: 25 } ],
    minimum: 1,                // pieces pour envoyer une demande
    minimumPro: 10,            // pieces pour le tarif pro (premier palier)
    remisePetitPro: 5,         // % sous 10 pieces, entreprise identifiee seulement
    plancherLivraison: 790,    // 7,90 EUR HT au moins pour une adresse
    etiquetteHT: 417,          // centimes
    // offre du 19/10/2026 : etiquette offerte du « du » au « au » inclus ; « jusqu'au » et « court » pour les textes
    etiquetteOfferte: { du: "2026-10-19T00:00:00+02:00", au: "2026-11-15T23:59:59+01:00", jusquau: "15 novembre", court: "15/11" },
    partLivraison: 10,         // %
    arrondiLivraison: 1000,    // a la dizaine d'euros inferieure
    plafondLivraison: 50000,   // 500 EUR HT
    parEnvoi: 790,             // 7,90 EUR HT
    tvaPlante: 10,             // % plante vivante
    tvaPot: 20,                // % pot
    tvaEtiquette: 20,          // % etiquette
    tvaLivraison: 20,          // % B2B (decision du 01/10/2026) ; 10 = le taux de Shopify sur sa ligne de livraison
    stockMinAffiche: 10,       // B2B : la page ne montre que les plantes et les pots d'au moins 10 pieces en stock (les mix gardent toute la taille)
    // 30/09/2026, pots en surstock (strateges/v2/pots_surstock.md), valide par Charles pour le B2B seulement :
    pastilleStockMin: 100,     // pastille « Grande série » sur les pots de plus de 100 pieces en stock
    potsMisEnAvant: ["XS-MBLA2", "XS-MBLA1"],   // metal noir XS : en tete de grille et pot par defaut en petite taille
    gestePotNoirHT: 400,       // equipe : jusqu'a 4 EUR HT par pot noir XS sur le sur-mesure (50 pieces et plus)
    gesteJusquau: "2027-01-31",
    quantiteMax: 5000
  };

  // "10", 10, " 10 pcs " -> 10 ; tout le reste -> null
  function entier(v) {
    if (typeof v === "number") return Number.isInteger(v) ? v : null;
    const m = String(v == null ? "" : v).trim().match(/^(\d{1,6})(?:\s*(?:pcs?|pi[eè]ces?|x))?$/i);
    return m ? parseInt(m[1], 10) : null;
  }

  // prix TTC en euros (29, "29.00", "29,00") -> centimes
  function centimes(v) {
    const n = typeof v === "number" ? v : parseFloat(String(v).replace(",", "."));
    return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) : null;
  }

  function tauxRemise(pieces, pro) {
    const t = REGLES.paliers.reduce((t, p) => (pieces >= p.des ? p.taux : t), 0);
    return t === 0 && pro && pieces > 0 ? REGLES.remisePetitPro : t;
  }

  function prochainPalier(pieces) {
    return REGLES.paliers.find(p => p.des > pieces) || null;
  }

  // l'etiquette est-elle offerte a cet instant (millisecondes ou Date) ? marge : millisecondes de grace apres la fin
  // (le serveur donne 30 minutes a une demande partie de la page juste avant minuit)
  function etiquetteOfferte(instant, marge) {
    const o = REGLES.etiquetteOfferte;
    if (!o) return false;
    const t = instant instanceof Date ? instant.getTime() : Number(instant);
    const du = Date.parse(o.du), au = Date.parse(o.au);
    return Number.isFinite(t) && Number.isFinite(du) && Number.isFinite(au) && t >= du && t <= au + (Number(marge) || 0);
  }

  const ht = (ttc, taux) => Math.round((ttc * 100) / (100 + taux));

  // prix unitaire HT d'une piece, en centimes : plante (10 %) + pot (20 %), chacun arrondi au centime
  function unitaireHT(planteTTC, potTTC) {
    return ht(planteTTC, REGLES.tvaPlante) + ht(potTTC, REGLES.tvaPot);
  }

  /*
    lignes : [{ planteTTC: 25, potTTC: 19, qte: 20, etiquette: true }]
    livraison : { mode: "une" } ou { mode: "plusieurs", envois: 38 }
    renvoie { ok, erreurs, pieces, lignes, brut, etiquettes, nbEtiquettes, taux, remise,
              net, livraison, totalHT, tva, totalTTC, parCadeau, accesPro, prochain }
    tous les montants en centimes
  */
  // options : { pro: true } quand l'entreprise est identifiee (SIRET ou TVA) : remise de 5 % sous 10 pieces ;
  // { etiquetteOfferte: true } pendant l'offre (etiquetteOfferte) : etiquettes a 0, leur valeur dans etiquettesOffertes
  function calculer(lignes, livraison, options) {
    const pro = !!(options && options.pro);
    const offerte = !!(options && options.etiquetteOfferte === true);
    const erreurs = [];
    const detail = [];
    (Array.isArray(lignes) ? lignes : []).forEach((l, i) => {
      const qte = entier(l && l.qte);
      const plante = centimes(l && l.planteTTC), pot = centimes(l && l.potTTC);
      if (qte === null || qte < 1) { erreurs.push(`Ligne ${i + 1} : quantité invalide`); return; }
      if (qte > REGLES.quantiteMax) { erreurs.push(`Ligne ${i + 1} : quantité trop grande`); return; }
      if (plante === null || pot === null) { erreurs.push(`Ligne ${i + 1} : prix inconnu`); return; }
      const hPlante = ht(plante, REGLES.tvaPlante), hPot = ht(pot, REGLES.tvaPot);
      detail.push({ index: i, qte, plante: hPlante, pot: hPot, unite: hPlante + hPot, total: (hPlante + hPot) * qte, etiquette: !!(l && l.etiquette) });
    });

    const pieces = detail.reduce((s, d) => s + d.qte, 0);
    const brut = detail.reduce((s, d) => s + d.total, 0);
    const brutPlantes = detail.reduce((s, d) => s + d.plante * d.qte, 0);
    const nbEtiquettes = detail.filter(d => d.etiquette).reduce((s, d) => s + d.qte, 0);
    const valeurEtiquettes = nbEtiquettes * REGLES.etiquetteHT;
    const etiquettes = offerte ? 0 : valeurEtiquettes;
    const baseRemise = brut + etiquettes;
    let taux = tauxRemise(pieces, pro);
    let remise = Math.round((baseRemise * taux) / 100);
    // Jamais plus cher en commandant moins : on ne paie jamais plus que le palier suivant,
    // a composition proportionnelle (N pieces paient au plus P/N fois le net du palier P).
    let plafonne = false;
    const suivant = prochainPalier(pieces);
    if (suivant && pieces > 0) {
      // meme formule et memes arrondis que le calcul au palier suivant, pour ne jamais ecarter d'un centime
      const basePalier = Math.round((baseRemise * suivant.des) / pieces);
      const netPalier = basePalier - Math.round((basePalier * suivant.taux) / 100);
      if (baseRemise - remise > netPalier) {
        remise = baseRemise - netPalier;
        taux = Math.round((remise * 1000) / baseRemise) / 10;   // taux affiche, au dixieme
        plafonne = true;
      }
    }
    const net = brut + etiquettes - remise;

    let frais = 0, envois = null;
    const mode = livraison && livraison.mode === "plusieurs" ? "plusieurs" : "une";
    if (mode === "plusieurs") {
      envois = entier(livraison.envois);
      if (envois === null || envois < 1) { erreurs.push("Nombre d'envois invalide"); envois = 0; }
      frais = envois * REGLES.parEnvoi;
    } else {
      const dixPourCent = Math.floor((net * REGLES.partLivraison) / 100);
      frais = Math.min(Math.floor(dixPourCent / REGLES.arrondiLivraison) * REGLES.arrondiLivraison, REGLES.plafondLivraison);
      if (pieces > 0) frais = Math.max(frais, REGLES.plancherLivraison);
    }

    const totalHT = net + frais;
    // la remise se repartit au prorata : plantes d'un cote (10 %), pots et etiquettes de l'autre (20 %) ; la livraison
    // rejoint la base de son taux (REGLES.tvaLivraison)
    const remisePlantes = baseRemise ? Math.round((brutPlantes * remise) / baseRemise) : 0;
    const bases = ventiler(brutPlantes - remisePlantes, (brut - brutPlantes) + etiquettes - (remise - remisePlantes), frais);
    const base10 = bases.base10, base20 = bases.base20, tva = bases.tva;
    return {
      ok: erreurs.length === 0,
      erreurs, pieces, lignes: detail, brut, etiquettes, nbEtiquettes, taux, remise, net, plafonne, pro,
      etiquetteOfferte: offerte, etiquettesOffertes: offerte ? valeurEtiquettes : 0,
      // taux exact a deux decimales, arrondi vers le haut : a porter tel quel sur le brouillon Shopify,
      // pour que la remise appliquee par Shopify ne soit jamais plus petite que celle du plafond
      tauxBrouillon: !plafonne ? taux : baseRemise ? Math.ceil((remise * 10000) / baseRemise) / 100 : 0,
      livraison: { mode, envois, montant: frais, plafonnee: mode === "une" && frais === REGLES.plafondLivraison },
      totalHT, tva, totalTTC: totalHT + tva, tvaDetail: { base10, base20 },
      parCadeau: pieces ? Math.round(totalHT / pieces) : 0,
      accesPro: pieces >= REGLES.minimumPro,
      prochain: prochainPalier(pieces)
    };
  }

  // les bases de TVA : plantes au taux des plantes, pots et etiquettes au taux des pots, la livraison au sien (meme calcul
  // pour la page et le script ; sert aussi au « prix du site » de la page)
  function ventiler(netPlantes, netAutres, frais) {
    const b = {};
    const ajouter = (taux, montant) => { b[taux] = (b[taux] || 0) + montant; };
    ajouter(REGLES.tvaPlante, netPlantes);
    ajouter(REGLES.tvaPot, netAutres);
    ajouter(REGLES.tvaLivraison, frais);
    const tva = Object.keys(b).reduce((s, t) => s + Math.round((b[t] * Number(t)) / 100), 0);
    return { base10: b[10] || 0, base20: b[20] || 0, tva: tva, bases: b };
  }

  // 183679 -> "1 836,79 €" (espaces insecables, comme le site)
  function euros(c) {
    const s = (Math.abs(c) / 100).toFixed(2).split(".");
    const milliers = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return (c < 0 ? "−" : "") + milliers + "," + s[1] + " €";
  }

  return { REGLES, calculer, ventiler, tauxRemise, prochainPalier, unitaireHT, entier, centimes, euros, etiquetteOfferte };
});
